import RegisterForm from "../../components/form/RegisterForm";

export default function Register () {
  return (

     <div className="m-auto w-[80%] space-y-4">
        <h1 className="font-[Phudu] text-primary font-black text-[2em]">Register</h1>
        <RegisterForm />
      </div>
  )
}
